// extracted by css-extract-rspack-plugin
export default {"cls1":"EvaluationClaimCard-cls1_rW4","cls2":"EvaluationClaimCard-cls2__-Q EvaluationClaimCard-cls1_rW4"};